<!--
 * @Author: your name
 * @Date: 2021-05-25 17:06:38
 * @LastEditTime: 2021-05-25 17:35:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\components\newfile\new3.vue
-->


<template>
  <div class="new1">
      

<p>
    &nbsp;&nbsp;
</p>
<p style="margin-bottom:16px;text-align:center">
    <strong><span style="font-family: 宋体;font-size: 21px"><span style="font-family:宋体">余庆县龙溪镇天然气利用项目</span>LNG储罐顺利完成吊装</span></strong><strong><span style="font-family: 宋体;font-size: 21px"><br/></span></strong>
</p>
<p style="text-indent: 37px">
    <span style=";font-family:宋体;font-size:19px">11月23日，余庆县龙溪镇LNG气化站2台60m³LNG储罐及工艺附属设备全部顺利</span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">安装完成</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">，</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">成为</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">龙溪镇供气工程项目建设又</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">一里程碑</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">。</span></span>
</p>
<p style=";text-indent:36px;text-align:center">
    <img width="440" height="587" src="../../assets/Information/zx7.png"  style="background:url(../../assets/Information/zx7.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:宋体;font-size:16px">&nbsp;</span>
</p>
<p style=";text-indent:41px;text-align:center">
    <span style=";font-family:宋体;font-size:16px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:19px">&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:宋体;font-size:19px">LNG储罐单体高</span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">15</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">米、外径</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">2.75</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">米，重</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">19.15</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">吨、容积</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">56m³</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">，为工艺区最大的单体设备。为确保吊装工作安全、有序地开展，余庆公司与神州管道安装公司</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">反复论证</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">吊装方案，做足了前期准备工作。</span></span>
</p>
<p style="text-indent: 37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">吊装施工当天</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">上午，</span>2台大型吊车准时进场就位，经作业方案交底和安全交底后，相关作业人员各司其职，严格按照储罐及撬装设备的吊装方案有序开展吊装作业。集团总工程师崔国华，贵州神州公司总经理杨启华</span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">，</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">余庆公司副总经理吴长松、神州管道安装公司总经理胡小亮</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">及工程管理人员在现场监督</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">吊装方案执行。</span></span>
</p>
<p style="text-align:center">
    <img width="382" height="287" src="../../assets/Information/zx8.png" style="background:url(../../assets/Information/zx8.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:宋体;font-size:16px">&nbsp;</span>
</p>
<p style="text-align:center">
    <span style=";font-family:宋体;font-size:16px"><span style="font-family:宋体">（集团总工程师崔国华在现场指导吊装）</span></span>
</p>
<p style="text-align:center">
    <img width="280" height="311" src="../../assets/Information/zx9.png" style="background:url(../../assets/Information/zx9.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:宋体;font-size:16px">&nbsp;&nbsp;</span>
</p>
<p style="text-align:center">
    <span style=";font-family:宋体;font-size:16px"><span style="font-family:宋体">（贵州神州燃气公司杨总在现场监督施工）</span></span>
</p>
<p style="text-indent: 37px">
    <span style=";font-family:宋体;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent: 37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">下午</span>13：30，随着最后一颗螺帽紧固完成，现场响起一片掌声，经过连续6个多小时的奋战，2台印制有“神州</span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">燃气</span></span><span style=";font-family:宋体;font-size:19px">”</span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">logo</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">的储罐稳稳落座，巍然耸立，随后</span>2台储罐撬、2台空温气化器等7台附属设备也相继全部顺利吊装就位。</span>
</p>
<p style="text-align:center">
    <img width="479" height="359" src="../../assets/Information/zx10.png" style="background:url(../../assets/Information/zx10.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:宋体;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">余庆公司接下来将全力以赴，一</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">方面</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">加快完成附属用房等土建工程施工，</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">另一方面</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">加快完成</span>LNG场站工艺设备及管道安装连接，争取按期实现项目的完工投产目标任务。</span>
</p>
<p style="margin-bottom: 16px">
    <span style=";font-family:宋体;font-size:19px">&nbsp;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:19px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:宋体">（文</span><span style="font-family:宋体">/图：柯亚平）</span></span>
</p>
<p>
    <br/>
</p>



  </div>

</template>
<script>

  import router from '@/router'

  export default {
    components: {

    },
    data() {
      return {
        htmls:''

      }
    },
    created(){

    },
    methods:{


    }
  }
</script>
<style lang="sass">

</style>

